<style lang="scss">
.calls {
}
</style>

<!-- eslint-disable -->
<template>
    <div class="calls row">
      <div class="col-12">
        <h2 cy="page-title" class="font-weight-bolder mb-2 full-width">Video Call Details <span v-if="call">- {{call.status}}  {{ (call.status === 'Funded' || call.status === 'AwaitingPayment') ? '(Awaiting Confirmation)' : ''}}</span></h2>
        <router-link :to="{ name: 'calls' }" class="d-inline-block mb-2">
          &laquo; Back to calls
        </router-link>

        <section v-if="!loading">
          <section v-if="prison && call">
            <call-details-requested v-if="call.status === 'Requested'"></call-details-requested>
            <call-details-completed v-if="call.status === 'Completed'"></call-details-completed>
            <call-details-approved v-if="call.status === 'Approved'"></call-details-approved>
            <call-details-cancelled v-if="call.status === 'Cancelled'"></call-details-cancelled>
            <call-details-rejected v-if="call.status === 'Rejected'"></call-details-rejected>
            <call-details-awaiting-confirmation v-if="call.status === 'AwaitingPayment' || call.status === 'Funded'"></call-details-awaiting-confirmation>
          </section>
          <section v-else>
            <p>There was a problem getting your call data, please refresh and try again</p>
          </section>
        </section>

        <div v-else>
          <b-spinner variant="primary" label="Loading call"></b-spinner>
        </div>
      </div>
    </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import CallDetailsRequested from '@/views/calls/callDetails/CallDetailsRequested';
import CallDetailsApproved from '@/views/calls/callDetails/CallDetailsApproved';
import CallDetailsCancelled from '@/views/calls/callDetails/CallDetailsCancelled';
import CallDetailsAwaitingConfirmation from '@/views/calls/callDetails/CallDetailsAwaitingConfirmation';
import CallDetailsCompleted from '@/views/calls/callDetails/CallDetailsCompleted';
import CallDetailsRejected from '@/views/calls/callDetails/CallDetailsRejected';
import VisitService from "@/services/VisitService";

export default {
  name: 'CallDetails',
  components: {
    CallDetailsRequested,
    CallDetailsApproved,
    CallDetailsCancelled,
    CallDetailsAwaitingConfirmation,
    CallDetailsCompleted,
    CallDetailsRejected,
  },
  props: {},
  data() {
    return {
      loading: true,
      firstVisit: false,
    };
  },
  watch: {
    $route(to, from) {
      this.getPrisonAndCallData();
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
      additionalVisitors: state => state.callDetails.additionalVisitors,
    }),
  },
  mounted() {
    this.getPrisonAndCallData();
  },
  methods: {
    async getPrisonAndCallData() {
      this.loading = true;
      await this.$store.dispatch('prison/getPrison');
      await this.$store.dispatch('callDetails/getCall', this.$route.params.id);

      const { data } = await VisitService.getVisitorsPreviousVisits(this.call.visitor.user_id);
      this.$store.commit('callDetails/SET_VISITORS_FIRST_CALL', !data?.length);

      // Finished loading
      this.loading = false;
    },
  },
}
</script>
